var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.to ? 'router-link' : 'button',_vm._g(_vm._b({tag:"component",staticClass:"app-button",class:{
    basic: _vm.basic,
    error: _vm.error,
    success: _vm.success,
    transparent: _vm.transparent,
    inverted: _vm.inverted,
    outline: _vm.outline,
    primary: _vm.primary,
    secondary: _vm.secondary,
    tertiary: _vm.tertiary,
    fluid: _vm.fluid,
    small: _vm.small,
    muted: _vm.muted,
    icon: _vm.icon,
    'no-shadow': _vm.noShadow,
    'light-rounded': _vm.lightRounded,
    'space-between': _vm.spaceBetween,
    'full-width': _vm.fullWidth,
    'show-loading': _vm.showLoading,
  }},'component',{
    ..._vm.$attrs,
    to: _vm.to,
    type: _vm.type,
    form: _vm.form,
    disabled: _vm.disabled,
  },false),_vm.$listeners),[(_vm.loading)?_c('div',{staticClass:"loading-wrapper"},[_c('font-awesome-icon',{attrs:{"icon":"circle-notch","spin":""}})],1):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }